/* @sravni/react-header version 0.2.43 */
import { __rest, __read, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, useTheme } from '@sravni/react-utils';
import modules_3d0bf2ca from '../styles/ContentWidget.module.less.js';

var generateUrl = function (domain, theme) {
    var origin = typeof window !== 'undefined' ? window.location.origin : undefined;
    try {
        var url = new URL("/ugc-widgets/news-widget/horizontal/header/" + theme + "/", domain || origin);
        return url.toString();
    }
    catch (e) {
        console.error(domain + " is wrong url base");
        return;
    }
};
var ContentWidget = React.forwardRef(function (props, ref) {
    var domain = props.domain, className = props.className, rest = __rest(props, ["domain", "className"]);
    var cx = useStyles(modules_3d0bf2ca);
    var _a = __read(useTheme(), 1), theme = _a[0];
    var url = generateUrl(domain, theme);
    return (React.createElement("div", __assign({ ref: ref, className: cx('wrapper', className) }, rest),
        React.createElement("iframe", { src: url, width: 573, height: 350 })));
});

export { ContentWidget };
//# sourceMappingURL=ContentWidget.js.map
